export const POST_DATA_REQUEST = "POST_DATA_REQUEST"
export const POST_DATA_SUCCESS = "POST_DATA_SUCCESS"
export const POST_DATA_FAILURE = "POST_DATA_FAILURE"